import { Clause3Home } from "../../pages/clause3";

export const clause3 = [
  {
    path: 'clause3',
    element: <Clause3Home />,
  },
];
